<script>
  export let progress
</script>
<div>
  <span class="vec-text-4xl">{progress.watched}/{progress.total}</span> <span class="vec-text-sm vec-uppercase">watched</span>
</div>
